
import { defineComponent } from "vue";
import api, { Template, SheqsyMessageList, RequestParams, TemplateSignalType } from "../../api/backend-api";
import { getHumanDate } from "../../util/luxonDateHelpers"
import format from "xml-formatter";
import { AxiosError } from "axios";
import ErrorBlock from "@/components/ErrorBlock.vue";

interface State {
  msg: string;
  template: Template;
  errors: AxiosError[];
  sheqsy_message: SheqsyMessageList;
}

export default defineComponent({
  name: "ReceiverTemplateForm",
  components: { ErrorBlock },
  mounted() {
    this.$nextTick(() => {
      this.callGetTemplate();
    });
  },
  data: (): State => {
    let template = { } as Template;
    let message_list = { } as SheqsyMessageList;
    return {
      msg: "Template",
      template: template,
      sheqsy_message: message_list,
      errors: [],
    };
  },
  methods: {
    getHumanDate,
    formatXml(xml: string): string {
      return format(xml, {collapseContent: false});
    },
    callDelete() {
      this.errors = [];
      api
        .deleteReceiverTemplate(this.template.id)
        .then(() => {
          this.$router.push('/receiver/template')
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
    callSave() {
      this.errors = [];
      const saveButton = document.getElementById('save')
      if (saveButton) {
        saveButton.classList.toggle('disabled')
        saveButton.textContent = '...'
      }
      api
        .saveReceiverTemplate(this.template)
        .then(() => {
          this.$router.go(0)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
          if (saveButton) {
            saveButton.classList.toggle('disabled')
            saveButton.textContent = 'save'
          }
        });
    },
    callGetTemplate() {

      this.errors = [];
      let template_id = '';
      if (typeof this.$route.params.slug != 'string') {
        throw new Error("Invalid url");
      }
      template_id = this.$route.params.slug

      const params = { 
        Paging: { Limit: 50 },
        Sorting: { Pattern: 'Message' }
      } as RequestParams
      api.getSheqsyMessageList(params)
        .then((response) => {
          this.sheqsy_message = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });

      api
        .getReceiverTemplate(template_id)
        .then((response) => {
          if (!response.data.SignalType) {
            response.data.SignalType = { 
              'id': '',
              'Message': '',
              'Supported': false
            } as TemplateSignalType
          }
          this.template = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
  }
});
